import { produce } from 'immer';
import * as actions from '../constants/action-types';

export default (state = {}, { type, payload }) =>
    produce(state, (draft) => {
        switch (type) {
            case actions.GET_TALENT_POOL_LIST:
                draft.loading = true;
                draft.errors.message = null;
                break;

            case actions.RECEIVED_TALENT_POOL_LIST:
                draft.loading = false;
                draft.stats = payload.stats;
                draft.list = payload.list;
                draft.filters = payload.filters;
                break;

            case actions.TALENT_POOL_LIST_ERROR:
                draft.loading = false;
                draft.errors.message = payload.message;
                break;

            case actions.DELETE_TALENT_POOL_ENTRIES:
                draft.deleting = true;
                draft.deleteStatus = {
                    successCount: 0,
                    failureCount: 0,
                    message: null,
                };
                break;

            case actions.DELETE_TALENT_POOL_ENTRIES_SUCCESS:
                draft.deleting = false;
                draft.deleteStatus = {
                    successCount: payload.successCount,
                    failureCount: payload.failureCount,
                };
                break;

            case actions.DELETE_TALENT_POOL_ENTRIES_ERROR:
                draft.deleting = false;
                draft.deleteStatus = {
                    successCount: 0,
                    failureCount: 0,
                    message: payload.message,
                };
                break;

            case actions.DELETE_TALENT_POOL_ENTRIES_RESET:
                draft.deleting = false;
                draft.deleteStatus = {
                    successCount: 0,
                    failureCount: 0,
                    message: null,
                };
                break;
        }
    });
